import type { CoordEntry, CoordItem } from "../../types";
import { GROUP_ORDER } from "../../types";
import type { MixCoordinate } from "./types";

function catalogItemsById(entries: readonly CoordEntry[]): Map<string, CoordItem> {
  const result = new Map<string, CoordItem>();
  for (const entry of entries) {
    for (const item of entry.items) {
      if (!result.has(item.id)) result.set(item.id, item);
      if (item.primagi?.itemId) {
        const legacyId = `PRIMAGI-${item.primagi.itemId}`;
        if (!result.has(legacyId)) result.set(legacyId, item);
      }
    }
  }
  return result;
}

export type MixEntryBuildResult = {
  entries: CoordEntry[];
  missingItemIds: string[];
};

export function buildMixEntries(
  mixes: readonly MixCoordinate[],
  catalogEntries: readonly CoordEntry[],
): MixEntryBuildResult {
  const byId = catalogItemsById(catalogEntries);
  const missingItemIds = new Set<string>();
  const entries = mixes.map((mix): CoordEntry => {
    const items: CoordItem[] = [];
    const added = new Set<string>();
    for (const group of GROUP_ORDER) {
      for (const id of mix.items[group] ?? []) {
        const item = byId.get(id);
        if (!item) {
          missingItemIds.add(id);
          continue;
        }
        const key = `${item.id}\n${item.url}`;
        if (added.has(key)) continue;
        added.add(key);
        items.push(item);
      }
    }
    return {
      key: `mix:${mix.scope}:${mix.id}`,
      name: mix.name,
      url: "",
      star: "",
      brand: mix.brand,
      category: null,
      items,
      mix: { id: mix.id, scope: mix.scope },
    };
  });
  return { entries, missingItemIds: [...missingItemIds] };
}
